import { useState, useEffect, memo, useCallback } from 'react';
import { I18n } from 'aws-amplify';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@material-ui/core';
import { styleCM, elStyle } from './ContractTableHandlerCss';
import {
    CONTRACT_SCREEN_MANAGEMENT,
    FIELDS_VALIDATE,
    YEAR,
    MONTH
} from '@/common/constant/NormalContractManagementConstant';
import { filterUnitLabel, transformFieldName } from './ContractHandler';
import Utils from '@/common/utils/utils';
import { handleValidate } from '../UpdateContract/UpdateContractHandler';
import Constant from '@/common/constant/Constant';
import { renderDisplayPriceCycle } from '../NormalViewContractDetailHanlder';

function ContractTable({
    currentScreen,
    setIsUpdateConfirm,
    settingData,
    setSettingData,
    isAdvanceSetting,
    paymentCycle,
    product
}) {

    const handleSettingData = (inputValue, field, message='') => {      
        setSettingData(prev => ({
            ...prev,
            [field]: {
                ...prev[field],
                quantity: {
                    ...prev[field].quantity,
                    update: inputValue
                },
                error: message
            }
        }));
    };

    const handlerInputChange = (inputValue, field) => {
        setIsUpdateConfirm(true);
        handleSettingData(inputValue, field);
    };

    const handleOnBlur = (inputValue, field) => {
        const val = field !== FIELDS_VALIDATE.GENERAL_USER.TITLE && Utils.isEmptyString(inputValue) ? '0' : inputValue.trim();
        const message = handleValidate(val, field);
        handleSettingData(Utils.convertNumber(val), field, message);
    }

    const getUnitPrice = (price) => {
        let unitPrice = price;
        if(paymentCycle?.code === MONTH.CODE) {
            unitPrice = price * (1 + Number(product.increaseRate)/100);
        } else {
            unitPrice = price * 12;
        }

        return Math.round(unitPrice);
    }

    return (
        <Typography component="div">
            <Box
                component="p"
                className="contract-confirm-label"
                {...elStyle.contract_confirm_label}
            >
                {isAdvanceSetting
                    ? I18n.get('CM-LABEL-ADDITONAL-OPTION')
                    : I18n.get('CM-LABEL-BASIC')}
            </Box>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ width: '35%' }}>
                                {isAdvanceSetting ? (
                                    <Box {...elStyle.fz14}>
                                        {I18n.get('CM-LABEL-ADDITONAL-OPTION')}
                                    </Box>
                                ) : (
                                    <Box {...elStyle.fz14}>
                                        {I18n.get('CM-LABEL-COLLUMN-BASIC')}
                                    </Box>
                                )}
                            </TableCell>
                            <TableCell align="left" style={{ width: '35%' }}>
                                <Box {...elStyle.fz14}>{I18n.get('CM-LABEL-COLLUMN-QUANTITY')}</Box>
                            </TableCell>
                            <TableCell align="right" style={{ width: '20%' }}>
                                <Box {...elStyle.fz14}>
                                    {I18n.get('CM-LABEL-COLLUMN-UNIT-PRICE')}
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {!Utils.isEmptyObject(settingData) &&
                            Object.entries(settingData).map((data, index) => {
                                const [fieldName, options] = data;
                                return (
                                    <TableRow key={index}>
                                        <TableCell style={{ width: '35%' }}>
                                            <Box {...styleCM.d_flex_column}>
                                                <Box {...elStyle.fz14}>
                                                    {transformFieldName(fieldName)}
                                                </Box>
                                                {currentScreen === CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN && (
                                                    <Box {...elStyle.fz12_green}>
                                                        {I18n.get('CM-LABEL-CURRENT')}
                                                    </Box>
                                                )}
                                            </Box>
                                        </TableCell>

                                        <TableCell align="left" style={{ width: '35%' }}>
                                            <Box {...styleCM.d_flex_column}>
                                                {currentScreen === CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN && fieldName !== 'basicCharge' ? (
                                                    <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 5 }}>
                                                        <TextField
                                                            className="form-control-input form-control-wrapInput form-control-hg32 setting-inputs"
                                                            variant="outlined"
                                                            spellCheck={false}
                                                            autoComplete="seriously-please-don't-autocomplete"
                                                            type={'text'}
                                                            value={options?.quantity?.update}
                                                            onFocus={e => e.preventDefault()}
                                                            onChange={e => handlerInputChange( e.target.value, fieldName )}
                                                            onBlur={e => handleOnBlur(e.target.value, fieldName)}
                                                            onWheel={e => e.target.blur()}
                                                            helperText={options?.error}
                                                            error={
                                                                !Utils.isEmptyString(options?.error)
                                                            }
                                                        />
                                                        <Box {...elStyle.fz14}>
                                                            
                                                            {filterUnitLabel(fieldName)}
                                                        </Box>
                                                    </Box>
                                                ) : (
                                                    <Box {...elStyle.fz14}>
                                                        {options?.quantity?.update}&nbsp;
                                                        {filterUnitLabel(fieldName)}
                                                    </Box>
                                                )}

                                                {currentScreen === CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN && (
                                                    <Box {...elStyle.fz12_green}>
                                                        {options?.quantity?.current}&nbsp;
                                                        {filterUnitLabel(fieldName)}
                                                    </Box>
                                                )}
                                            </Box>
                                        </TableCell>

                                        <TableCell align="right" style={{ width: '20%' }}>
                                            <Box {...styleCM.d_flex_column}>
                                                <Box {...elStyle.fz14}>
                                                    {getUnitPrice(options.price.update || 0)}&nbsp;
                                                    {renderDisplayPriceCycle(paymentCycle)}
                                                </Box>
                                                {currentScreen === CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN && (
                                                    <Box {...elStyle.fz12_green}>
                                                        {getUnitPrice(options.price.current || 0)}&nbsp;
                                                        {renderDisplayPriceCycle(paymentCycle)}
                                                    </Box>
                                                )}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Typography>
    );
}

export default memo(ContractTable);
